<template>
    <base-modal :visible="true" @close="$emit('close')" title="Edit tag">
        <tag-form
            :init_data="copy(tag)"
            :loading="update.loading"
            @cancel="$emit('close')"
            @submit="submit"/>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import TagForm from './TagForm.vue';

export default {
    components: { TagForm },
    props: ['space', 'tag'],
    computed: mapState('columns', ['update']),
    methods: {
        async submit(data) {
            await this.$store.dispatch('tags/update', {
                space_id: this.space.id,
                tag_id: this.tag.id,
                data,
            });

            this.$store.commit('tags/change_tag', { id: this.tag.id, tag: data });

            this.$emit('close');
        },
    },
};
</script>
